
import React from "react";
import { Star, Pin } from "lucide-react";

type EntriesSectionHeaderProps = {
  title: string;
  icon?: "star" | "pin";
};

export const EntriesSectionHeader = ({ title, icon }: EntriesSectionHeaderProps) => {
  return (
    <h2 className="text-xl font-semibold mb-4 flex items-center">
      {icon === "star" && <Star className="h-5 w-5 fill-yellow-400 text-yellow-400 mr-2" />}
      {icon === "pin" && <Pin className="h-5 w-5 mr-2" />}
      {title}
    </h2>
  );
};
